import styled from 'styled-components';

import { Image as BaseImage } from '@xing-com/image';
import {
  mediaConfined,
  mediaConfinedOnly,
  mediaWide,
  mediaWideNavless,
} from '@xing-com/layout-tokens';
import { Link as BaseLink } from '@xing-com/link';
import {
  cornerRadius4XL,
  cornerRadiusXXL,
  space3XL,
  space4XL,
  space5XL,
  space6XL,
  spaceL,
  spaceS,
  spaceXL,
  spaceXXL,
  xdlColorTextOnLight,
  xdlPalettePurpleRain05,
} from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

import { SignUpButton } from '../sign-up-button';
import herobg from './salary-background-desktop.svg';
import herobgRotated from './salary-background-mobile.svg';

const Content = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${spaceS};

  padding: ${spaceL} ${spaceXL} ${spaceXXL};

  @media ${mediaConfinedOnly} {
    padding: ${space3XL} ${spaceXXL};
  }

  @media ${mediaWide} {
    padding: ${space5XL} ${space4XL} ${space5XL} ${space6XL};
    gap: ${spaceS};
  }
`;

const Button = styled(SignUpButton)`
  margin-top: ${spaceS};
  @media ${mediaConfined} {
    width: fit-content;
  }
`;

const Title = styled(Hero)`
  white-space: nowrap;
  color: ${xdlColorTextOnLight};
`;

const Container = styled.div`
  padding: ${spaceL} ${spaceL} ${space4XL};
  display: flex;
  justify-content: end;
  width: 100%;

  @media ${mediaConfined} {
    order: 1;
    padding: ${spaceL} ${spaceL} ${space4XL};
  }

  @media ${mediaWide} {
    padding: ${spaceL} ${spaceXL} ${space4XL};
  }
`;

const Image = styled(BaseImage)`
  @media ${mediaConfinedOnly} {
    max-width: 480px;
  }

  @media ${mediaWide} {
    max-width: 660px;
  }
`;

const Section = styled.section`
  border-radius: ${cornerRadiusXXL};

  background-color: ${xdlPalettePurpleRain05};
  background-image: url(${herobgRotated});
  background-repeat: no-repeat;

  @media ${mediaConfined} {
    background-image: url(${herobg});
    background-size: cover;
    background-position: right;
  }

  @media ${mediaWideNavless} {
    border-radius: ${cornerRadius4XL};
    background-size: contain;
  }
`;

const Link = styled(BaseLink)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  @media ${mediaConfined} {
    flex-direction: row;
  }
`;

export const Styled = {
  Content,
  Container,
  Button,
  Section,
  Image,
  Link,
  Title,
};
